import styled from 'styled-components';

export const Container = styled.div`
  a:hover {
    color: #0081c6;
  }

  p {
    margin-bottom: 10px;
    font-size: 14px;
  }

  p:nth-child(4) strong {
    color: #0081c6;
    font-family: MuseoSans-300;
  }

  p:nth-child(7) strong {
    color: #c0311a;
    font-family: MuseoSans-300;
  }

  @media (max-width: 768px) {
    p {
      margin-bottom: 10px;
      font-size: 12px;
    }
  }
`;
